<div class="form-group" [class.bb]="showBorderBottom" [class.mb-1]="!showBorderBottom" data-type="checkbox" *ngIf="facetGroup.length > 0">
  <label *ngIf="facetName" [for]="facetName">{{ facetName }}</label>

  <div *ngFor="let facet of facetGroup; let facetCount = count">
    <!-- Main facet -->
    <!-- Show checkbox if more then one facet -->
    <ng-container *ngIf="facetCount > 1 || facetCount === 1">
      <app-input-checkbox
        (change)="onChange($event.target.checked, facet.value)"
        [label]="getCheckboxLabel(facet)"
        [(checked)]="facet.checked"
        [useHtml]="true"
      >
      </app-input-checkbox>
    </ng-container>
    <!-- if useSingleState is set to true and there is only one facet, we need to display it without the checkbox -->
    <!-- <div *ngIf="useSingleState && facetCount == 1" class="subhead-2 text-grey">
      {{ useLabelWhenOne === false ? (facet.value | number) + " " + unit : facet.label }}
    </div> -->

    <!-- Sub facet -->
    <div class="subfacet-container" *ngIf="facet.checked && facetSubGroup.length && getSubFacets(facet.label) as subFacets">
      <ng-container *ngIf="subFacets.length > 1">
        <app-input-checkbox
          (change)="onChange($event.target.checked, subFacet.value)"
          *ngFor="let subFacet of subFacets"
          [label]="getCheckboxLabel(subFacet)"
          [(checked)]="subFacet.checked"
          [useHtml]="true"
        >
        </app-input-checkbox>
      </ng-container>
      {{ subFacet | json }}
      <div *ngIf="useSingleState && subFacets.length == 1" class="subhead-2 text-grey" style="margin-left: 31px">
        {{ useLabelWhenOne === false ? (subFacets[0].value | number) + " " + unit : subFacets[0].label }}
      </div>
    </div>
  </div>
  <div class="mt-1 text-green cursor-pointer" *ngIf="lessMoreText == 'more'" (click)="showMoreFacets()">More +</div>
  <div class="mt-1 text-green cursor-pointer" *ngIf="lessMoreText == 'less'" (click)="showLessFacets()">Less -</div>
</div>
